module.exports = {
    title: "Branches",
    crud: {
        create: "Create Branch",
        edit: "Edit Branch",
        view: "View Branch",
    },
    table: {
        branchName: 'Branch Name',
        companyName: 'Company Name',
        address: 'Address',
        isHeadOffice: 'Head Office?',
        locationChangeCount: 'Location Change Count',
    },
    detail: {
        title: 'City View',
        currencyName: 'currencyName,'
    },
    form: {
        branch_name: 'Branch Name',
        company_name: 'Company Name',
        head_office: 'Head Office',
        email: 'Email',
        address: 'Address',
        country: 'Country',
        state: 'State',
        city: 'City',
        cp_email: 'Contact Person Email',
        cp_name: 'Contact Person Name',
        contact_no: 'Contact No.',
        cp_contact_no: 'Contact Person Contact No.',
        start_date: 'Start Date',
        end_date: 'End Date',
    },
    placeholder: {
        country: "Select Country",
        state: "Select State"
    },
    validation: {
        required: {
            branch_name: 'Please enter branch name.',
            email: 'Please enter email.',
            address: 'Please enter address.',
            contact_no: 'Please enter contact no.',
            cp_name: 'Please enter contact person name.',
            cp_email: 'Please enter contact person email.',
            cp_contact_no: 'Please enter contact person contact no.',
        }
    },
}
